import { Pagination } from "@mui/material"

import { observer } from "mobx-react-lite"

export const PaginationBlock = observer(
  ({ setRowsPerPage, setPage, currentPage, pagesCount, perPage }) => {
    // Debugging

    return (
      <div className='flex md:justify-end justify-center'>
        <div className='flex lg:flex-row items-center justify-end md:flex-row flex-col sm:text-base text-sm'>
          {pagesCount > 1 && (
            <div className='w-full'>
              <div className='w-full flex justify-end'>
                <Pagination
                  color='secondary'
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "gray.main",
                      "&.Mui-selected": {
                        color: "white",
                      },
                    },
                  }}
                  count={pagesCount}
                  page={currentPage}
                  shape='rounded'
                  onChange={(_, page) => setPage?.(page)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
)
